import styled from 'styled-components';

const warningColor = '#eb3124';

export const WarningCell = styled.div`
  display: flex;
  align-items: center;

  color: ${warningColor};
  font-weight: 700;

  .triangle {
    margin-left: 10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 17.3px 10px;
    border-color: transparent transparent ${warningColor} transparent;

    position: relative;
    > div {
      color: #fff;
      font-size: 10px;

      position: absolute;
      top: 3px;
      left: 0;
      right: 0;

      display: flex;
      justify-content: center;
    }
  }
`;
